import { render, staticRenderFns } from "./Jurnal.vue?vue&type=template&id=cce7f23c"
import script from "./Jurnal.vue?vue&type=script&lang=js"
export * from "./Jurnal.vue?vue&type=script&lang=js"
import style0 from "./Jurnal.vue?vue&type=style&index=0&id=cce7f23c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports